export default __webpack_public_path__ + "static/media/forestly-expl-nn-05_EN.117f587e.png";